module.exports = __webpack_public_path__ + "static/media/client.077fdb23.svg";